const STORYLANE_URL_PREFIXES = [
  'https://shine.storylane.io/',
  'https://app.storylane.io/'
];

const isStorylaneUrl = (str?: string) => {
  if (!str) {
    return false;
  }

  // This ensures the resulting `src` attribute for the `iframe` can be trusted
  // It acts as an allow-list
  const isValid = STORYLANE_URL_PREFIXES.some((prefix) =>
    str.startsWith(`${prefix}share/`) || str.startsWith(`${prefix}demo/`)
  );

  return isValid;
};

const sanitizeStorylaneUrl = (str?: string) => {
  if (!str) {
    return null;
  }

  const isValid = isStorylaneUrl(str);
  if (!isValid) {
    return null;
  }

  /**
   * The share version would render an additional iframe compared to demo version.
   * Even though content creators should not,
   * we can expect them to unintentionally use this share version
   * because it is exposed by Storylane within the Share instructions.
   */
  const matchedPrefix = STORYLANE_URL_PREFIXES.find((prefix) => str.startsWith(prefix));
  
  if (matchedPrefix && str.startsWith(`${matchedPrefix}share/`)) {
    return str.replace(`${matchedPrefix}share/`, `${matchedPrefix}demo/`);
  }

  return str;
};

const ARCADE_URL_PREFIXES = [
  'https://app.arcade.software/',
  'https://demo.arcade.software/'
];

const isArcadeUrl = (str?: string) => {
  if (!str) return false;
  return ARCADE_URL_PREFIXES.some((prefix) => str.startsWith(prefix));
};

const sanitizeArcadeUrl = (str?: string) => {
  if (!str) return null;
  if (!isArcadeUrl(str)) return null;

  try {
    const url = new URL(str);
    
    if (url.hostname === 'app.arcade.software' && url.pathname.startsWith('/share/')) {
      url.hostname = 'demo.arcade.software';
      url.pathname = url.pathname.replace('/share/', '/');
    }

    if (url.hostname === 'demo.arcade.software') {
      url.searchParams.set('embed', 'true');
      return url.toString();
    }
  } catch {
    return null;
  }

  return null;
};

export { isStorylaneUrl, sanitizeStorylaneUrl, isArcadeUrl, sanitizeArcadeUrl };
